import { useMutation } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export type ForgotPasswordRequest = {
  email: string;
};

export type ForgotPasswordResponse = {
  success: boolean;
  message: string;
};

export const resetPassword = async (
  credentials: ForgotPasswordRequest
): Promise<ForgotPasswordResponse> => {
  const response = await Axios.post<ForgotPasswordResponse>(
    POST_URL().forgotPass,
    credentials
  );
  return response.data;
};

export function useForgotPassword() {
  const { t } = useTranslation();
  return useMutation<
    ForgotPasswordResponse,
    AxiosError<BaseError>,
    ForgotPasswordRequest
  >((credentials: ForgotPasswordRequest) => resetPassword(credentials), {
    onSuccess: () => {
      toast.success(t('password-reset-request-sent'));
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError: (error: any) => {
      let messages: string[] = [];

      if (Array.isArray(error?.response?.data?.detail)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        messages = error.response.data.detail.map((err: any) => {
          const field = err.loc?.[1] ?? 'field';
          return `${field}: ${err.msg}`;
        });
      } else if (error?.response?.data?.message) {
        messages = [error.response.data.message];
      } else {
        messages = [t('an-error-has-occurred')];
      }

      toast.error(messages.join('\n'));
    },
    useErrorBoundary: false
  });
}
